<div class="content-margin register-page">
  <section class="register-content">
    <h1 class="ewrs-page-title">Welcome to Employee Workspace Reservation System (EWRS) registration.</h1>
    <p class="register-email">{{ email }}</p>

    <app-edit-user-fields class="register-form" [isRegistration]="true"></app-edit-user-fields>
  </section>
</div>
